import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import logo from '../assets/logo.png';  // Importing the logo
import logo2 from '../assets/logo2.png';
import './CSS/Login.css'; // Reuse the Login.css file for styling

class DirectTokenVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      message: '',
      errorMessage: '',
      isSubmitting: false
    };
  }

  // Handle token input change
  handleTokenChange = (e) => {
    this.setState({ token: e.target.value });
  }

  // Submit the token for verification
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });

    try {
      const response = await fetch('/directtokenverification', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: this.state.token })
      });

      const data = await response.json();

      if (response.ok) {
        this.setState({ message: data.message, errorMessage: '', isSubmitting: false });

        // Redirect to /certificate1 after successful token verification
        this.props.history.push('/faceregister');
      } else {
        this.setState({ errorMessage: data.message, message: '', isSubmitting: false });
      }
    } catch (error) {
      this.setState({ errorMessage: "An error occurred. Please try again later.", message: '', isSubmitting: false });
    }
  }

  render() {
    return (
      <div className="token-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className='logo' src={logo} alt="Logo" />
          <br />
          <div><Link to='/'>Home</Link></div>
          <br />
          <h2>Token Authentication</h2>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="token">Enter Token</label>
                      <input
                        type="text"
                        className="form-control"
                        name="token"
                        id="token"
                        value={this.state.token}
                        onChange={this.handleTokenChange}
                        required
                      />
                    </div>
                    <button type="submit" className="btn btn-dark" disabled={this.state.isSubmitting}>
                      {this.state.isSubmitting ? 'Submitting...' : 'Submit Token'}
                    </button>
                  </form>
                  {this.state.message && <div className="alert alert-success mt-3">{this.state.message}</div>}
                  {this.state.errorMessage && <div className="alert alert-danger mt-3">{this.state.errorMessage}</div>}
                  <div className="text-center mt-3">
                    <div>Powered by</div>
                    <img className='logo2' src={logo2} alt="Logo 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DirectTokenVerification);
